import {
  currentScreenAndDialog,
  SYSBaseElement,
  SYSDialog,
  TemplateResult,
} from "../.."
import { FocusSet } from "../../global/globalapi"
import type { DialogType } from "./sysdialogbase"
import { SYSBaseDialog } from "./sysdialogbase"

export type DialogGetParts = {
  header?: () =>
    | TemplateResult
    | TemplateResult[]
    | Promise<TemplateResult>
    | Promise<TemplateResult[]>
  title?: () => any
  body?: () =>
    | TemplateResult
    | TemplateResult[]
    | Promise<TemplateResult>
    | Promise<TemplateResult[]>
  footer?: () =>
    | TemplateResult
    | TemplateResult[]
    | Promise<TemplateResult>
    | Promise<TemplateResult[]>
  keyHandlerFn?: any
  closedCallbackFn?: any
  dismissedCallbackFn?: any
  closeOnDismiss?: boolean
  emptySpaceClickHandlerFn?: any
  updatedHandlerFn?: any
  afterRenderHandlerFn?: any
  type?: () => DialogType
  instance?: any
  customClass?: () => string
}

export type _DialogHolderParams = {
  dialogParts: DialogGetParts
  dialogType: SYSDialog
  instance?: any
}
export class SYSDialogBase extends SYSBaseElement {
  dialogHolderParams: _DialogHolderParams
  async updated() {
    if (this.dialogHolderParams.dialogParts.updatedHandlerFn) {
      this.dialogHolderParams.dialogParts.updatedHandlerFn()
    }
    let dialog = currentScreenAndDialog.dialogFocusSet.dialog
    let instance = currentScreenAndDialog.dialogFocusSet.instance
    if (dialog && dialog === this.dialog && instance === this.dialogInstance) {
      currentScreenAndDialog.dialogFocusSet.dialog = undefined
      let id = `ovl-dialog-${dialog}-${instance}`
      FocusSet(id, {
        ignoreIfAlreadySetOnScreenOrDialog: true,
      })
    }
    await super.updated()
  }

  async afterRender() {
    if (this.dialogHolderParams.dialogParts.afterRenderHandlerFn) {
      await this.dialogHolderParams.dialogParts.afterRenderHandlerFn()
    }
    await super.afterRender()
  }
}
